// Destination Country Step

import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  StyleSheet,
  FlatList,
  Image,
  Platform,
} from "react-native";
import Colors from "../../../constants/colors";
import SearchIcon from "../../../../../../assets/images/SearchIcon.svg";
import { ComponentStyles } from "../../../constants/componentStyles";
import { inputAssistDisabledProps } from "./FloatingTextInputComponent";
import SearchInputComponent from "./SearchInputComponent";

type FlatListDataComponentProps<T> = {
  title?: string;
  subTitle?: string;
  searchPlaceHolder?: string;
  searchValue?: string;
  filteredData?: T[];
  onSearchChangeText: (text: string) => void;
  renderItem: (item: T) => JSX.Element;
  searchTestID?: string;
  flatListTestID?: string;
  /** When true, title/subtitle/search stay fixed; only the list scrolls. Parent must give this component a bounded height. */
  stickyHeader?: boolean;
};

function FlatListDataComponent<T>({
  title,
  subTitle,
  searchPlaceHolder,
  searchValue,
  filteredData,
  onSearchChangeText,
  renderItem,
  searchTestID,
  flatListTestID,
  stickyHeader = false,
}: FlatListDataComponentProps<T>) {

  const [isFocused, setIsFocused] = useState(false);

  const borderColor = isFocused
    ? Colors.black
    : Colors.textInputBackground;

  const borderWidth = isFocused ? 1.5 : 1;

  const stickySection = (
    <View style={{ marginBottom: 8, width: "100%", alignSelf: "stretch" }}>
      {title && <Text style={styles.title}>{title}</Text>}
      {subTitle && <Text style={styles.subtitle}>{subTitle}</Text>}
      {/* <View style={[styles.searchContainer, { borderColor, borderWidth }]}>
        <SearchIcon width={24} height={24}/>
        <TextInput
          testID={searchTestID}
          style={styles.searchInput}
          placeholder={searchPlaceHolder}
          placeholderTextColor={"#666"}
          value={searchValue}
          onChangeText={onSearchChangeText}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...inputAssistDisabledProps}
        />
      </View> */}
      <SearchInputComponent
        marginTop={19}
        testID={searchTestID}
        placeholder={searchPlaceHolder}
        value={searchValue}
        onChangeText={onSearchChangeText}
      />
    </View>
  );

  if (stickyHeader) {
    return (
      <View style={styles.containerSticky}>
        <View style={styles.stickySection}>{stickySection}</View>
        <FlatList
          testID={flatListTestID}
          data={filteredData ?? []}
          keyExtractor={(item, index) => index.toString()}
          style={styles.listSticky}
          contentContainerStyle={styles.listContentSticky}
          renderItem={({ item }) => renderItem(item)}
          nestedScrollEnabled={true}
          showsVerticalScrollIndicator={true}
        />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      {stickySection}
      <FlatList
        testID={flatListTestID}
        data={filteredData}
        keyExtractor={(item, index) => index.toString()}
        style={{ flex: 1, width: "100%" }} 
        renderItem={({ item }) => renderItem(item)}
        nestedScrollEnabled={true}
        showsVerticalScrollIndicator={true}
      />
    </View>
  );
}

export default FlatListDataComponent;

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
  },
  containerSticky: {
    flex: 1,
    minHeight: 0,
    backgroundColor: Colors.white,
  },
  stickySection: {
    flexShrink: 0,
    width: "100%",
    alignSelf: "stretch",
  },
  listSticky: {
    flex: 1,
    width: "100%",
    minHeight: 0,
  },
  listContentSticky: {
    paddingBottom: 24,
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 8
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
  },
  searchContainer: {
    flexDirection: 'row',
    backgroundColor: Colors.searchBackground,
    padding: 8,
    borderRadius: 24,
    marginBottom: 19,
    marginTop: 24
  },
  searchInput: {
    flex: 1,
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: "400",
    lineHeight: 24,
    color: Colors.subTitleColor,
    marginLeft: 8,
    // ...( { outlineWidth: 0 } as any ),
    ...(Platform.OS === 'web' && {
      outlineWidth: 0,
      outlineStyle: 'none',
      border: 'none',
      boxShadow: 'none',
    } as any),
  },
  countryRow: {
    backgroundColor: Colors.white,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    borderBottomWidth: 0,
    justifyContent: 'space-between'
  },
  flag: {
    fontSize: 22,
    marginRight: 12,
  },
  countryName: {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: ComponentStyles.textFamily,
    lineHeight: 20,
    color: Colors.darkGrey,
    paddingLeft: 16
  },
  radioContainer: {
    marginLeft: 12,
  },
  radioButton: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#D1D5DB',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.radioButtonFilled
  },
  radioOuter: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: "#D1D5DB",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: '#D1D1D1'
  },
  radioOuterSelected: {
    borderColor: "#000",
  },
  radioInner: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#000",
  },
  selectedText: {
    marginTop: 16,
    fontSize: 16,
    fontWeight: "500",
    color: "#111827",
  },
});
